"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShopifyConfigOutSerializer = void 0;
exports.ShopifyConfigOutSerializer = {
    _fromJsonObject(object) {
        return {};
    },
    _toJsonObject(self) {
        return {};
    },
};
//# sourceMappingURL=shopifyConfigOut.js.map